import { Injectable } from "@angular/core";
import { ApiServiceService } from "./api-service.service";
import { environment } from "../../../../../../public/environments/environment";
import { catchError, throwError } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class AssessmentService {

    constructor(private apiService: ApiServiceService) { }

    getAvailableTests() {
        return this.apiService.get(`${environment.apiUrl}/personality-test/get-available-tests`).pipe(catchError(this.handleError));
    }

    getTestQuestions(testId: any) {
        return this.apiService.get(`${environment.apiUrl}/personality-test/questions?test_id=${testId}`).pipe(catchError(this.handleError));
    }

    skipTest() {
        return this.apiService.post(`${environment.apiUrl}/personality-test/skip-test`).pipe(catchError(this.handleError));
    }
    
    saveTestAnswers(data: any) {
        return this.apiService.post(`${environment.apiUrl}/personality-test`, data).pipe(catchError(this.handleError));
    }

    handleError(error: any) {
        return throwError(error);
    }
}